import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-signout',
    standalone:false,
    templateUrl: './signout.component.html',
    styleUrl: './signout.component.scss'
})
export class SignoutComponent {

  constructor(private router: Router) { }


  ngOnInit(): void {
    localStorage.clear()
    sessionStorage.clear()
    this.router.navigate(['/']);

  }
}
